import { render, staticRenderFns } from "./policy-task-definition-form.vue?vue&type=template&id=0d881534"
import script from "./policy-task-definition-form.vue?vue&type=script&lang=js"
export * from "./policy-task-definition-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports